export default {
  'sendticket.sendticket': 'SEND Request',
  'sendticket.sentsuccessfully': 'Request Sent Successfully',
  'sendticket.replytickets': 'Reply Requests',
  'sendticket.you': 'You',
  'sendticket.operator': 'Operator',
  'sendticket.reply': 'REPLY',
  'sendticket.createdat': 'Created At',
  'sendticket.laststatus': 'Last Status',
  'sendticket.ticketid': 'Request ID',
  'sendticket.closeticketquestion':
    'Has your request been successfully answered?',
  'sendticket.closeticket': 'Yes,Close this request',
  'sendticket.notcloseticket': 'No',
  'sendticket.closedsuccessfully': 'Request closed successfully',
  'sendticket.downloadfile': 'Download File',
  'sendticket.subject': 'Subject',
  'sendticket.ticketId': 'Request ID',
  'sendticket.sender': 'Sender',
  'sendticket.reply': 'Reply',
  'sendticket.yes': 'yes,Was answered',
  'sendticket.no': 'not yet ',
  'sendticket.pleaseTryAgain': 'Please try again ',
  'sendticket.reply': 'Reply',
  'sendticket.today': '( Today )',
  'sendticket.yesterday': '( yesterday )',
  'sendticket.daysago': 'days ago',
  'sendticket.hoursago': 'hours ago',
  'sendticket.minutesago': 'minutes ago',
  'sendticket.send': 'send',
  'sendticket.description': 'Description',
  'sendticket.justnow': 'Just Now',
};
